import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

export interface SaasStackDeleteDialogData {
  stackName: string;
}

@Component({
  selector: 'app-saas-stack-delete-dialog',
  standalone: true,
  imports: [FormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule],
  template: `
    <div class="dialog-heading">
      <span class="dialog-icon"><mat-icon>delete_forever</mat-icon></span>
      <div>
        <h2 mat-dialog-title>SaaS-Instanz löschen</h2>
        <p>Das Deployment und alle Container dieses Stacks werden entfernt.</p>
      </div>
    </div>
    <mat-dialog-content>
      <div class="stack-context">
        <span>Docker-Stack</span>
        <strong>{{ data.stackName }}</strong>
      </div>
      <p class="warning-copy">Diese Aktion kann nicht rückgängig gemacht werden.</p>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>PB40-Token</mat-label>
        <mat-icon matPrefix>key</mat-icon>
        <input matInput type="password" [(ngModel)]="token" autocomplete="off" spellcheck="false"
          cdkFocusInitial (keydown.enter)="submit()">
      </mat-form-field>
      <small><mat-icon>lock</mat-icon>Der Token wird nur für diese Anfrage verwendet und nicht gespeichert.</small>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">Abbrechen</button>
      <button mat-flat-button color="warn" type="button" [disabled]="!token.trim()" (click)="submit()">
        <mat-icon>delete</mat-icon>Instanz löschen
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    :host { display: block; color: var(--app-surface-dark, #1e293b); }
    .dialog-heading { display: flex; gap: .9rem; padding: 1.5rem 1.5rem .4rem; }
    .dialog-icon { display: grid; place-items: center; flex: 0 0 2.6rem; height: 2.6rem; border-radius: .75rem; color: #fff; background: var(--app-warn, #dc3545); }
    h2[mat-dialog-title] { margin: 0; padding: 0; font-size: 1.2rem; font-weight: 600; }
    .dialog-heading p { margin: .25rem 0 0; color: var(--app-surface-light, #64748b); line-height: 1.45; }
    mat-dialog-content { display: grid; gap: 1rem; min-width: min(27rem, 72vw); padding-top: 1rem; }
    .stack-context { display: flex; justify-content: space-between; gap: 1rem; padding: .8rem .9rem; border: 1px solid rgba(220, 53, 69, .25); border-radius: .65rem; background: rgba(220, 53, 69, .06); }
    .stack-context span { color: var(--app-surface-light, #64748b); }
    .stack-context strong { overflow-wrap: anywhere; font-weight: 600; }
    .warning-copy { margin: -.15rem 0 0; color: var(--app-warn, #b42335); font-size: .88rem; }
    mat-form-field { width: 100%; }
    small { display: flex; align-items: center; gap: .35rem; margin-top: -.45rem; color: var(--app-surface-light, #64748b); line-height: 1.45; }
    small mat-icon { width: 1rem; height: 1rem; font-size: 1rem; }
    mat-dialog-actions { padding: .75rem 1.5rem 1.25rem; }
    @media (max-width: 560px) { .dialog-heading { padding: 1.1rem 1rem .25rem; } mat-dialog-content { min-width: 0; padding: .8rem 1rem; } mat-dialog-actions { padding: .6rem 1rem 1rem; } }
  `]
})
export class SaasStackDeleteDialogComponent {
  token = '';

  constructor(
    readonly dialogRef: MatDialogRef<SaasStackDeleteDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) readonly data: SaasStackDeleteDialogData
  ) { }

  submit(): void {
    const token = this.token.trim();
    if (token) this.dialogRef.close(token);
  }
}
